import { api } from '@/lib/apiClient';

// ============================ DTOs (mirror SmartTravel.Application.Features.Globalization) ============================
export interface EffectiveRtl {
  direction: 'ltr' | 'rtl';
  isRtl: boolean;
  textAlign: string;
  fontFamily?: string | null;
  numberDirection: string;
  layoutMirroring: boolean;
  forced: boolean;
}

export interface RtlConfiguration {
  id: number;
  writingDirection: string; // Auto | LTR | RTL
  forceRtl: boolean;
  fontFamily?: string | null;
  numberDirection: string; // LTR | RTL
  layoutMirroring: boolean;
  alignmentRules?: string | null;
  componentBehaviour?: string | null;
}

export type RtlConfigRequest = Omit<RtlConfiguration, 'id'>;

export const rtlApi = {
  effective: () => api.get<EffectiveRtl>('/rtl/effective'),
  config: () => api.get<RtlConfiguration | null>('/rtl/config'),
  saveConfig: (body: RtlConfigRequest) => api.put<RtlConfiguration>('/rtl/config', body),
};
